import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarPedidosBloqueados(axios, parametros) { 
    parametros.operacao = 'buscarPedidosBloqueados';

    let retorno = {};
    await axios.santriGET('/rest/orcamento', parametros, 20, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(erro => {
      retorno = Biblioteca.retornoRequisicao('S', erro, undefined)
    })
  
    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarPedidosBloqueados.js